export const Constants: Record<string, string> = {
  // スキル・経験業務リクエスト外部リンク定義
  BIYO_SKILL_REQUEST_LINK:
    "https://docs.google.com/forms/d/e/1FAIpQLSe43_yVcQfVrGyF8iJLUVikhQ_gpk8xwWnNIojmtod1bh-twg/viewform",
  KAIGO_SKILL_REQUEST_LINK:
    "https://docs.google.com/forms/d/e/1FAIpQLSe85OH4stjDiX-VDCP34jz3dcF-8hmlUH8x4YW4POiABinv5A/viewform",
};
